import { selectWarehouseStatus } from 'containers/Warehouses/warehousesSlice'
import { addNotification } from 'containers/Notifications/notificationsSlice'
import { selectUserFavorites } from 'containers/Login/loginSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import useWarehouses from 'hooks/useWarehouses'
import { useHistory } from 'react-router-dom'
import MagNumber from 'components/MagNumber'
import magbox from 'assets/img/magbox.webp'
import htbox from 'assets/img/htbox.webp'
import { useSelector } from 'react-redux'
import { useReduxDispatch } from 'store'
import Error from 'components/Error'
import { POST } from 'rest/request'
import { POPUPS } from './Popups'
import { useState } from 'react'
import { api } from 'rest/urls'

const type = process.env.REACT_APP_TYPE

const Favorite = () => {
  const status = useSelector(selectWarehouseStatus)
  const favorites = useSelector(selectUserFavorites)
  const [isLoading, setLoading] = useState(false)
  const warehouses = useWarehouses()

  const { push } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('dashboard')
  const runAction = async ({ method, payload, url, type }) => {
    if (type !== 'request' && type !== 'redirect') return
    if (type === 'redirect') {
      push(url)
      return
    }
    if (isLoading || method !== 'POST') return
    setLoading(true)

    try {
      const body = url === 'genericAction' ? { payload } : payload
      const response = await POST(`${api}${url}`, { body })
      if (response?.result === 'ok') console.log(response)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <div className='dashboard__favorite'>
      {favorites && favorites.length > 0
        ? favorites.map(({ id, related }) => {
          const actions = Object.values(related?.actions)
          return <div
            key={id}
            className='favorite__card --right'
            onClick={() => {
              if (status !== 'succeed') {
                dispatch(addNotification({ message: t('loadingPleaseWait'), type: 'info' }))
              } else if (related?.object === 'Warehouse' && related?.id) {
                if (warehouses.find(warehouse => warehouse.objectId === related.id)) {
                  push(`/warehouses/${related.id}`)
                } else {
                  push(window.location.pathname, LOCATION_STATES.popup({ type: POPUPS.removeFavorite, relatedId: related?.id }))
                }
              }
            }}>
            <div className='favorite__card__column'>
              <MagNumber
                isLight
                rentableType={related?.rentableType === 'parking'
                  ? 'parking'
                  : 'warehouse'}
                number={related.number}
              />
              <div className='favorite__card__head'>{related.address}</div>
              <div
                className='favorite__card__footer'
                onClick={e => {
                  if (actions.length > 0) {
                    e.stopPropagation()
                  }
                }}>
                {actions.length > 0
                  ? actions.map(({ open }, idx) => <ArrowBtn
                    key={idx}
                    text={open?.text}
                    className={type === 'rze01' ? '--black' : ''}
                    action={() => {
                      if (!open) return
                      runAction(open)
                    }}
                  />)
                  : <ArrowBtn
                    text={t('manage')}
                    className={type === 'rze01' ? '--black' : ''}
                    action={() => { }}
                  />}
              </div>
            </div>
            <img
              alt=''
              decoding='sync'
              src={related?.warehouseAnimation === 'custom' && (related?.warehouseTransparentPhoto || related?.warehousePhoto)
                ? (related.warehouseTransparentPhoto || related.warehousePhoto)
                : related?.warehouseAnimation === 'htbox'
                  ? htbox
                  : related?.warehouseAnimation?.includes('mm')
                    ? magbox
                    : htbox}
            />
          </div>
        })
        : <Error
          staticPos
          text={t('noFavorites')}
        />}
    </div>
  )
}

export default Favorite